import { TimeUnit } from "../enums/TimeUnit";
import { BoxMetrics } from "../interfaces/BoxMetrix";
import { MetricsMeasures } from "../interfaces/MetricType";

export class ComposedMetrics {
    constructor(public measure: MetricsMeasures | undefined, public timeUnit: TimeUnit){}
}